"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const createReference_1 = require("../../../app/dist/createReference");
exports.toolDef = {
    name: 'loom_create_reference',
    description: 'Create a new reference document in loom/refs/. Named {slug}-reference.md. Do NOT include the word "reference" in the title — the `-reference` suffix is added automatically (a trailing type word is stripped to avoid "x-reference-reference.md"). Pass `content` to write the body in the same call; omit it for a placeholder. Reference docs are born at status "active" (no draft gate). Returns the doc id, file path, and slug.',
    inputSchema: {
        type: 'object',
        properties: {
            title: { type: 'string', description: 'Human-readable reference title' },
            description: { type: 'string', description: 'Short description of what this reference covers (stored in frontmatter)' },
            content: { type: 'string', description: 'Optional markdown body (no frontmatter). When provided, replaces the placeholder body.' },
        },
        required: ['title'],
    },
};
async function handle(root, args) {
    const result = await (0, createReference_1.createReference)({
        title: args['title'],
        description: args['description'],
        content: args['content'],
    }, { getActiveLoomRoot: () => root, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
